import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const items = ['Quieres cuidar tu piel de forma natural y segura', 'Buscas alternativas reales a los productos comerciales', 'Te interesa la medicina tradicional y los remedios caseros', 'Quieres aprender una habilidad práctica y útil para tu familia', 'Deseas saber exactamente qué ingredientes usas a diario'];
export function WhoIsThisFor() {
  return <SectionWrapper id="para-quien" className="px-4 md:px-12 max-w-4xl mx-auto" data-id="element-253">
      <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-254">
        <div className="w-full md:w-1/2" data-id="element-255">
          <h2 className="text-3xl md:text-5xl font-playfair text-forest mb-8" data-id="element-256">
            Esta guía es para ti si...
          </h2>
          <ul className="space-y-6" data-id="element-257">
            {items.map((item, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-start" data-id="element-258">
                <div className="w-6 h-6 rounded-full bg-sage flex items-center justify-center shrink-0 mt-1 mr-4" data-id="element-259">
                  <Check className="w-4 h-4 text-white" data-id="element-260" />
                </div>
                <span className="text-lg text-brown/90 font-medium" data-id="element-261">
                  {item}
                </span>
              </motion.li>)}
          </ul>
        </div>

        <div className="w-full md:w-1/2 relative" data-id="element-262">
          <div className="absolute inset-0 bg-amber/20 rounded-full blur-3xl opacity-50" data-id="element-263"></div>
          <div className="relative bg-card p-8 rounded-3xl shadow-warm border border-sage/20 text-center" data-id="element-264">
            <h3 className="font-playfair text-2xl text-forest mb-4" data-id="element-265">
              No necesitas experiencia
            </h3>
            <p className="text-brown/80 leading-relaxed" data-id="element-266">
              Las recetas están explicadas de manera sencilla, paso a paso. Si
              sabes hervir agua, puedes hacer estas pomadas.
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}